/**
 * useTranslation — React hook for the i18n service.
 * Re-renders ALL components when language changes.
 *
 * Usage:
 *   const { t, currentLang, setLanguage, languages } = useTranslation();
 *   t("Settings")  // translates "Settings" to current language
 */
import { useState, useEffect, useCallback } from "react";
import i18n from "@/services/i18nService";

export default function useTranslation() {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const unsub = i18n.onChange(() => forceUpdate(n => n + 1));
    return unsub;
  }, []);

  const setLanguage = useCallback((code) => {
    i18n.setLanguageSync(code);
  }, []);

  return {
    t: (key, params) => i18n.t(key, params),
    currentLang: i18n.currentLang,
    setLanguage,
    languages: i18n.getLanguages(),
  };
}
